import { EditAdminFormResult } from '@common/schemas/forms/organisme';
import { UtilisateurAdminDto } from '@common/services/utilisateur';

export function mapEditAdminFormResult(result: EditAdminFormResult): Mapped {
  const {
    firstAdminLastName,
    firstAdminFirstName,
    firstAdminJob,
    firstAdminPhoneNumber,
    firstAdminEmail,

    secondAdminLastName,
    secondAdminFirstName,
    secondAdminJob,
    secondAdminPhoneNumber,
    secondAdminEmail,
  } = result;

  const firstAdminResult: UtilisateurAdminDto = {
    nom: firstAdminLastName,
    prenom: firstAdminFirstName,
    email: firstAdminEmail,
    telephone: firstAdminPhoneNumber,
    travail: firstAdminJob,
  };

  const secondAdminResult: UtilisateurAdminDto | undefined =
    secondAdminLastName ? {
      nom: secondAdminLastName,
      prenom: secondAdminFirstName,
      email: secondAdminEmail,
      travail: secondAdminJob,
      telephone: secondAdminPhoneNumber,
    } : undefined;

  return { firstAdminResult, secondAdminResult };
}

interface Mapped {
  firstAdminResult: UtilisateurAdminDto;
  secondAdminResult?: UtilisateurAdminDto;
}